import {AminoConverter} from "@shareledgerjs/amino";

export function createSbtAminoConverters(): Record<string, AminoConverter | "not_supported_by_chain"> {
  return {};
}
